<div id="ytb-player-container" class="container-fluid">
  <div class="row" [class.hide]="embededMode">
    <div class="container search-container">
      <div class="well well-lg" [class.margin-top]="!isInDictionariez">
        <div [class.input-group]="!isSmallScreen()">
          <h4 class="input-group-addon hidden-xs" id="captionz-title">
            <span>Captionz</span>
          </h4>
          <input
            type="text"
            class="form-control video-url text-search"
            [class.invalid-url]="invalidUrl"
            [formControl]="videoUrlCtrl"
            (keyup.enter)="onEnterKey()"
            placeholder="Enter YouTube video URL or search keyword..."
            aria-describedby="captionz-title"
            autofocus
            [ngModel]="searchText"
          />

          <a
            class="btn input-group-addon bg-success hidden-xs"
            (click)="openShares()"
            >Share this video!
          </a>
        </div>

        <p class="dictionaries-tip">
          <em *ngIf="isSearching">> Searching "{{ searchText }}":</em>

          <span
            *ngIf="!isSearching && (searchResults.length > 0 || invalidUrl)"
          >
            <em *ngIf="searchResults.length > 0">
              > Results for "{{ searchText }}"</em
            >
            <em *ngIf="invalidUrl">
              > No result found for "{{ searchText }}"</em
            >
            <span>
              in
              <label for="language-select" class="sr-only"
                >Spoken language</label
              >
              <ng-select
                class="inline-ng-select"
                [items]="availableVoiceLanguages"
                bindLabel="name"
                bindValue="en"
                [(ngModel)]="selectedVoiceLanguage"
                [searchFn]="languageSearchFn"
                [clearable]="false"
                (change)="onVoiceLanguageChange($event)"
              >
              </ng-select>
              <a
                href="https://pnl.dev/topic/991/captionz-major-update-to-make-youtube-more-useful-for-language-learning"
                target="_blank"
                rel="noopener"
                class="what-is-this-link"
                title="What is this?"
              >
                <span>?</span>
              </a>
            </span>
          </span>
          <em *ngIf="!isSearching && searchResults.length === 0 && !invalidUrl">
            > People are watching today:</em
          >
        </p>

        <div class="suggestions row">
          <div
            class="loader"
            *ngIf="isSearching || isLoadingPopularVideos"
          ></div>
          <div
            class="list-item col-xs-6  {{
              isSearching || isLoadingPopularVideos ? 'hidden' : 'visible-xs'
            }}"
            *ngFor="
              let s of (searchResults.length ? searchResults : suggestions)
                | slice : 0 : 4;
              let i = index
            "
          >
            <a
              href="javascript:void(0);"
              class="thumbnail"
              [ngClass]="{ active: i === indexInList }"
              [title]="s.title"
              (click)="openSuggestion(s)"
            >
              <img
                src="{{
                  s.img ||
                    'https://i.ytimg.com/vi/' + s.videoId + '/hqdefault.jpg'
                }}"
                alt="preview image"
              />
            </a>
          </div>
          <div
            class="list-item col-md-2 col-sm-2  {{
              isSearching || isLoadingPopularVideos ? 'hidden' : 'hidden-xs'
            }}  "
            *ngFor="
              let s of (searchResults.length ? searchResults : suggestions)
                | slice : 0 : 6;
              let i = index
            "
          >
            <a
              href="javascript:void(0);"
              class="thumbnail"
              [ngClass]="{ active: i === indexInList }"
              [title]="s.title"
              (click)="openSuggestion(s)"
            >
              <img
                src="{{
                  s.img ||
                    'https://i.ytimg.com/vi/' + s.videoId + '/hqdefault.jpg'
                }}"
                alt="preview image"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row fullscreen-wrapper" [class.in-fullscreen]="inFullscreen">
    <div class="col-md-8 col-sm-8 col-xs-12 ytb-player-wrapper">
      <div class="ul-bullets" *ngIf="bullets">
        <span
          *ngFor="let line of bullets; let i = index"
          class="list-group-item bullet-comment"
          [attr.data-index]="i"
          [attr.data-y]="line.yPos"
          [style.top]="line.top"
        >
          <span class="bullet-text"> {{ line.text }}</span>
        </span>
      </div>

      <div class="embed-responsive embed-responsive-16by9">
        <div id="ytb-player"></div>
      </div>
    </div>

    <div class="col-md-4 col-sm-4 col-xs-12 caption-man-wrapper">
      <app-caption-man></app-caption-man>
    </div>
  </div>

  <app-shares></app-shares>
</div>
